"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const utilitycheckmarkfilledsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-utilitycheckmarkfilledsm` : '') + (description ? ` desc-utilitycheckmarkfilledsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-utilitycheckmarkfilledsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-utilitycheckmarkfilledsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
    fill: "#207E15"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.09 14.24c-.12.03-.14-.04-.2-.1-.54-.55-1.37-2.13-1.98-2.41-1.16-.53-2.19.67-1.53 1.8.31.56 2.43 3.35 2.86 3.7.64.52 1.59.29 2.09-.33.76-.95 1.81-3.11 2.42-4.26.48-.9.92-1.83 1.36-2.74.14-.3.33-.58.46-.86.21-.45.82-1.61.9-2.01a1.24 1.24 0 0 0-2.26-.97c-.24.39-.45.87-.66 1.27l-.4.8a282.02 282.02 0 0 0-3.06 6.1v.01Z",
    fill: "#EBFFF1"
  }));
};
var _default = exports.default = utilitycheckmarkfilledsm;